module.exports = {"2024-01-01T00:00:00Z":14.0108,"2030-01-01T00:00:00Z":14.6404,"2043-01-01T00:00:00Z":15.1912,"2050-01-01T00:00:00Z":15.6211,"2062-01-01T00:00:00Z":16.13,"2070-01-01T00:00:00Z":16.7854,"2081-01-01T00:00:00Z":17.2573,"2091-01-01T00:00:00Z":17.86,"2098-01-01T00:00:00Z":18.5375}


//////////////////
// WEBPACK FOOTER
// ./src/components/core/predictivos/imagenes.json
// module id = 1090
// module chunks = 1